import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './product.css';

function ProductForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState({
    title: '',
    description: '',
    price: '',
    category: '',
    stock: '',
    imageUrl: '',
    isPublished: true,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!id) return;

    const fetchProduct = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/products/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProduct({
          title: res.data.title,
          description: res.data.description,
          price: res.data.price,
          category: res.data.category,
          stock: res.data.stock,
          imageUrl: res.data.imageUrl,
          isPublished: res.data.isPublished,
        });
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load product');
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProduct((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const payload = {
        title: product.title,
        description: product.description,
        price: Number(product.price),
        category: product.category,
        stock: Number(product.stock),
        imageUrl: product.imageUrl,
        isPublished: product.isPublished,
      };

      if (id) {
        await axios.put(`${process.env.REACT_APP_API_URL}/products/${id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSuccess('Product updated successfully');
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/products`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSuccess('Product created successfully');
        setProduct({ title: '', description: '', price: '', category: '', stock: '', imageUrl: '', isPublished: true });
      }

      setTimeout(() => {
        navigate('/my-products');
      }, 700);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save product');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="product-page">
      <h2>{id ? 'Edit Product' : 'Add New Product'}</h2>
      <form className="product-form" onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <label>
          Title
          <input name="title" value={product.title} onChange={handleChange} required />
        </label>
        <label>
          Description
          <textarea name="description" value={product.description} onChange={handleChange} rows="4" />
        </label>
        <label>
          Price
          <input name="price" type="number" min="0" value={product.price} onChange={handleChange} required />
        </label>
        <label>
          Category
          <input name="category" value={product.category} onChange={handleChange} />
        </label>
        <label>
          Stock
          <input name="stock" type="number" min="0" value={product.stock} onChange={handleChange} />
        </label>
        <label>
          Image URL
          <input name="imageUrl" value={product.imageUrl} onChange={handleChange} />
        </label>
        <label className="checkbox-label">
          <input
            name="isPublished"
            type="checkbox"
            checked={product.isPublished}
            onChange={handleChange}
          />
          Publish product
        </label>

        <button className="button primary-button" type="submit" disabled={loading}>
          {loading ? 'Saving...' : id ? 'Update Product' : 'Create Product'}
        </button>
      </form>
    </div>
  );
}

export default ProductForm;
